import { render, staticRenderFns } from "./CampoComTitulo.vue?vue&type=template&id=6cc8c8e6&"
import script from "./CampoComTitulo.vue?vue&type=script&lang=ts&"
export * from "./CampoComTitulo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports